// В.2.g: Нейро-хирург Зейн (liv_neyro_hirurg_zeyn, Герой Лив Лайф, 3/0/13).
// Пассивка: «Избыточное лечение (сверх максимума ХП) у союзных юнитов
//            превращается во временную Броню сверх лимита карты до конца хода».
//
// Реализация: registerOnHealOverflowObserver. Срабатывает после успешного
// healUnit с overflow > 0, если target — союзный ЮНИТ Зейна (не Герой).
// Применяет applyTemporaryBuff +0/overflow/0 с expiresAtTurn = currentTurn+1
// (снимется в Ф1 следующего хода через expireTemporaryBuffs).
//
// Молчание Зейна — пассивка отключена (это уже в каркасе observer'ов).
// Не применяется к самому Зейну (он Герой, не юнит) — фильтр по target.type.

import { registerOnHealOverflowObserver } from './heal.js';
import { registerImplementedAbility } from './warn-unimplemented.js';
import { applyTemporaryBuff } from '../../buffs.js';

export const HERO_ID = 'liv_neyro_hirurg_zeyn';
const LABEL = 'Зейн';
const SOURCE_ID = 'liv_neyro_hirurg_zeyn_overshield';

registerImplementedAbility(HERO_ID, 'passive');

registerOnHealOverflowObserver(HERO_ID, (state, zeyn, healEvent) => {
  if (!healEvent || (healEvent.overflow ?? 0) <= 0) return;
  const target = healEvent.target;
  if (!target) return;
  // Только союзные ЮНИТЫ (не Герой). target.ownerId === zeyn.ownerId уже
  // гарантирован side-aware-фильтром в runOnHealOverflowObservers.
  if (target.type !== 'unit') return;
  if (!target.isAlive || !target.isAlive()) return;
  const expiresAtTurn = state.currentTurn + 1;
  applyTemporaryBuff(
    state, target,
    { atk: 0, armor: healEvent.overflow, hp: 0 },
    expiresAtTurn,
    SOURCE_ID,
    `${LABEL} (overshield)`
  );
  state.log?.add(
    `🛡 ${target.name_ru} [${state.players?.[target.ownerId]?.name}]: ` +
    `+${healEvent.overflow} брони (overshield от ${LABEL})`
  );
});
